module.exports = __webpack_public_path__ + "files/observa4.e37f7258edb8b64219df8e8aa9163876.pdf";